module.exports = __webpack_public_path__ + "static/media/igtv-instagram-instagram-tv-svgrepo-com.15acb5f7.svg";